import Banner from './Banner';
import { BannerProps, BannerType } from './Banner.types';

export default Banner;

export type { BannerProps, BannerType };
